import React, { useEffect } from "react"
import { View, forwardRef, ViewProps, createStyles } from "@design-system/core"
import { scrolling, __DEV__ } from "@design-system/utils"

let totalModalCounts = 0

export interface ModalSheetOverlayProps extends ViewProps {
  withMask?: boolean

  scrollable?: boolean
}

const styles = createStyles((theme) => ({
  root: {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    height: "100vh",
    width: "100vw",
    position: "fixed",
    top: 0,
    overflowY: "hidden",
  },
  mask: {
    backgroundColor: theme.backgroundColors.overlay,
    position: "fixed",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
  scrollable: {
    overflowY: "auto",
  },
}))

export const ModalSheetOverlay = forwardRef<ModalSheetOverlayProps, "div">(
  (props, ref) => {
    const {
      accessibilityRole,
      ariaLabelledBy,
      withMask,
      scrollable,
      onClick,
      onKeyDown,
      children,
      style,
      testID,
    } = props

    useEffect(() => {
      totalModalCounts++
      scrolling.disable()

      return () => {
        if (--totalModalCounts <= 0) {
          scrolling.enable()
        }
      }
    }, [])

    return (
      <View
        accessibilityRole={accessibilityRole}
        aria-labelledby={ariaLabelledBy}
        style={[styles.root, scrollable && styles.scrollable, style]}
        onKeyDown={onKeyDown}
        onClick={onClick}
        testID={testID}
      >
        {withMask && <View style={styles.mask} />}
        {children}
      </View>
    )
  },
)

if (__DEV__) {
  ModalSheetOverlay.displayName = "ModalSheetOverlay"
}
